<template>
	<div class="dynamicList">
		<div  class="dynamicListCon">
			<div v-loading.fullscreen.lock="loading" class="project">
				<div v-for="(item,index) of list" :key="index" class="li" @click="detail(item.id)">
					<div class="name">
						{{item.title}}
					</div>
					<div class="lis">
						<img src="@/static/timeIcon.png" class="icon" />
						<div>
							{{item.created_at.split(' ')[0]}}
						</div>
					</div>
					<div class="lis platform">
						<img src="@/static/corIcon.png" class="logo" />
						<div>
							{{item.admin_id==1?'准聘':item.admin.name}}
						</div>
					</div>
				</div>
			</div>
			
			<div v-if="total>0" class="page">
				<el-pagination background :page-size="limit" layout="prev, pager, next" :total="total"
					@current-change='changePage'>
				</el-pagination>
			</div>
			
		</div>
	</div>
</template>

<script>
	export default {
		name: 'dynamicList',
		data() {
			return {
				loading: false,
				list: [],
				page:1,
				total:0,
				limit:15
			}
		},
		created() {
			this.type=this.$route.query.type
			this.getList()
		},
		methods: {
			// 获取列表
			getList() {
				this.loading = true
				let data = {
					page: this.page,
					limit: this.limit,
					type:this.type
				}
				this.$axios.get('/api/client/Common/getAnnouncements', {
					params: data
				}).then(res => {
					this.loading = false
					if (res.code == 200) {
						this.total = res.data.total
						this.list = res.data.data
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			changePage(e) {
				console.log(e, '---e')
				this.page = e
				this.getList()
			},
			detail(id){
				this.$router.push({ name: 'dynamicDe',query:{id:id}});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.dynamicList {
		position: relative;
		.dynamicListCon {
			position: relative;
			z-index: 2;
			width: 1200px;
			margin: 0 auto;
			padding: 24px 0;
			height: 800px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			flex-direction: column;
			.page {
				display: flex;
				align-items: center;
				justify-content: center;
				margin: 48px 0 0;
			}

			.project {
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				.li {
					position: relative;
					width: 390px;
					margin-right: 15px;
					margin-bottom: 16px;
					cursor: pointer;
					&:nth-child(3n) {
						margin-right: 0;
					}
					padding: 16px 22px;
					background-color: #FFF;
					border-radius: 8px;
					box-sizing: border-box;
					&:nth-child(13){
						margin-bottom: 0;
					}
					&:nth-child(14){
						margin-bottom: 0;
					}
					&:nth-child(15){
						margin-bottom: 0;
					}
					.name {
						color: #151515;
						font-size: 18px;
						font-weight: bold;
						margin-bottom: 14px;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;

					}

					.lis {
						display: flex;
						align-items: center;
						margin-bottom: 10px;
						font-size: 14px;

						&:last-child {
							margin-bottom: 0;
						}

						.icon {
							width: 24px;
							height: 24px;
							margin-right: 10px;
						}
					}
					
					.platform{
						font-size: 16px;
						color: #51A190;
						font-weight: bold;
						.logo{
							width: 24px;
							height: 24px;
							margin-right: 10px;
						}
					}

				}
			}


		}
	}
</style>